/*
  رحلة المي: الحركة (النهر، الكلور، البواري، الفقاعات، خط المي) تشتغل بس للخطوة اللي تبين بالشاشة،
  والخطوات اللي برا الشاشة تاخذ is-offscreen وحركتها تتوقف (أخف على الموبايل).
  بدون JS الحركة تشتغل عادي.
*/
(function () {
  function watch(list) {
    if (list.dataset.watching || !('IntersectionObserver' in window)) return;
    list.dataset.watching = 'true';

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          entry.target.classList.toggle('is-offscreen', !entry.isIntersecting);
        });
      },
      { rootMargin: '120px 0px' }
    );

    list.querySelectorAll('.hayat-journey__step').forEach((step) => observer.observe(step));
  }

  function init() {
    document.querySelectorAll('[data-journey-steps]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // بالمحرر: لما القسم ينعاد تحميله
  document.addEventListener('shopify:section:load', init);
})();
